import {
  type BaseTimeOffAPI,
  type GetEmployeeTimeOffsAPIResponse,
  type GetTimeOffTypesAPIResponse,
  type LeaveType,
  type TimeOffScope,
  TimeOffStatus,
  type TimeOffWithScopeAPI,
} from '@omnipresentgroup/types';

import { DEFAULT_ADMIN_USER } from '../users';

export const DEFAULT_TIME_OFF: BaseTimeOffAPI = {
  id: '27b0c97c-9e59-47c5-bf16-4c7bce6cb00b',
  leaveType: 'op:leave:sick' as LeaveType,
  employeeId: 'a1e89d20-61bb-4887-8b8b-f2782710dc75',
  companyId: 'F2WXbqrlPaVS',
  employeeNote: 'Sick',
  startDate: '2023-10-09',
  endDate: '2023-10-09',
  createdAt: '2023-10-10T09:41:05.427Z',
  createdBy: 'auth0|6267f9c2c5b606006fe1b773',
  updatedAt: '2023-10-10T09:41:05.428Z',
  updatedBy: 'auth0|6267f9c2c5b606006fe1b773',
  isTaken: true,
};

export const generateTimeOff = <T extends TimeOffScope>(
  override: Partial<TimeOffWithScopeAPI<T>> = {},
) => ({
  ...DEFAULT_TIME_OFF,
  ...override,
});

export const DEFAULT_TIME_OFF_RESPONSE: GetEmployeeTimeOffsAPIResponse<'employee'> =
  {
    [TimeOffStatus.taken]: [DEFAULT_TIME_OFF],
    [TimeOffStatus.scheduled]: [
      generateTimeOff({
        id: '5ceef5f1-71cc-42f6-8d0c-3b60d37fd391',
        employeeNote: 'Year off for me.',
        startDate: '2033-03-03',
        endDate: '2034-03-03',
        isTaken: false,
        firstDayAfternoonOnly: true,
        lastDayMorningOnly: true,
      }),
      generateTimeOff({
        id: 'baeb713a-391f-4f06-957f-cf4e3e1f935a',
        employeeNote: 'Some days off.',
        startDate: '2023-09-04',
        endDate: '2033-09-03',
        isTaken: false,
        deletedBy: DEFAULT_ADMIN_USER.authId,
        deletedAt: '2023-11-20T09:41:05.427Z',
        lastDayMorningOnly: true,
      }),
    ],
  };

export const DEFAULT_TIME_OFF_COMPANY_RESPONSE: GetEmployeeTimeOffsAPIResponse<'company'> =
  {
    [TimeOffStatus.taken]: [
      generateTimeOff<'company'>({
        employeeName: 'Alicia Jonson',
        firstDayAfternoonOnly: true,
      }) as TimeOffWithScopeAPI<'company'>,
    ],
    [TimeOffStatus.scheduled]: [
      generateTimeOff<'company'>({
        id: '5ceef5f1-71cc-42f6-8d0c-3b60d37fd391',
        employeeNote: 'Year off for me.',
        startDate: '2033-03-03',
        endDate: '2034-03-03',
        isTaken: false,
        employeeName: 'John Doe',
        lastDayMorningOnly: true,
        firstDayAfternoonOnly: true,
      }) as TimeOffWithScopeAPI<'company'>,
      generateTimeOff<'company'>({
        id: 'baeb713a-391f-4f06-957f-cf4e3e1f935a',
        employeeNote: 'Some days off.',
        startDate: '2023-09-04',
        endDate: '2033-09-03',
        isTaken: false,
        deletedBy: DEFAULT_ADMIN_USER.authId,
        deletedAt: '2023-11-20T09:41:05.427Z',
        employeeName: 'Jane Tomas',
        firstDayAfternoonOnly: true,
      }) as TimeOffWithScopeAPI<'company'>,
    ],
  };

export const DEFAULT_TIME_OFF_TYPES: GetTimeOffTypesAPIResponse = [
  {
    id: 'op:leave:compassionate',
    name: 'Compassionate',
    country_code: 'US',
  },
  {
    id: 'op:leave:sick',
    name: 'Sick',
    country_code: 'US',
  },
  {
    id: 'op:leave:vacation',
    name: 'Vacation',
    country_code: 'US',
  },
  {
    id: 'op:leave:maternity',
    name: 'Maternity',
    country_code: 'US',
  },
  {
    id: 'op:leave:paternity',
    name: 'Paternity',
    country_code: 'US',
  },
  {
    id: 'op:leave:holiday',
    name: 'Holiday',
    country_code: 'US',
  },
];
